import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import DocLink from 'ui-forms-components/links/DocLink';
import ConfigurationPanelHeader from 'FormsUI/components/editor/form/configuration/ConfigurationPanelHeader';
import { CAPTCHA_LEARN_MORE } from 'FormsCommonComponents/constants/KCSArticlePaths';
import { Text } from 'foundations-components/components/Text';
import { ConfigPanelWrapper } from 'FormsUI/components/editor/form/configuration/ConfigPanelWrapper';
import { FormFieldConfigHeader } from 'FormsUI/components/editor/form/configuration/FormFieldConfigHeader';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function langKey(suffix) {
  return `editor.form.config.${suffix}`;
}
const learnMoreLink = /*#__PURE__*/_jsx(DocLink, {
  path: CAPTCHA_LEARN_MORE,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: langKey('learnMore')
  })
});
const CaptchaConfigurationPanel = ({
  hideConfigurationPanel
}) => /*#__PURE__*/_jsxs(ConfigPanelWrapper, {
  "data-commenting-scroll-container": true,
  children: [/*#__PURE__*/_jsx(ConfigurationPanelHeader, {
    handleDone: hideConfigurationPanel
  }), /*#__PURE__*/_jsx(View, {
    paddingBlockStart: "1200",
    children: /*#__PURE__*/_jsx(FormFieldConfigHeader, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey('reCaptcha')
      })
    })
  }), /*#__PURE__*/_jsxs(View, {
    padding: "600",
    children: [/*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: langKey('captchaSource'),
        options: {
          learnMoreLink
        }
      })
    }), /*#__PURE__*/_jsx(Text, {
      marginBlockStart: "200",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: langKey('captchaDescription'),
        options: {
          learnMoreLink
        }
      })
    }), /*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey('captchaNotEditable')
      })
    })]
  })]
});
export default CaptchaConfigurationPanel;